import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES as FALLBACK_CATEGORIES } from '../mock';

const CategoryGrid = () => {
  const categories = FALLBACK_CATEGORIES;

  return (
    <section className="pt-2 pb-8 lg:pt-4 lg:pb-12 bg-[#FFFFFF]">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
        <div className="text-center mb-4 lg:mb-6">
          <h2 className="font-serif text-[24px] text-[#1a1a1a]">Explore by Category</h2>
        </div>
        <div className="flex sm:grid sm:grid-cols-3 gap-4 lg:gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide -mx-6 px-6 sm:mx-0 sm:px-0">
          {categories.map(cat => (
            <Link key={cat.id} to={cat.href} className="group block flex-shrink-0 w-full sm:w-auto snap-center">
              <div className="overflow-hidden aspect-[3/4] bg-[#f7f4ee]">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
                />
              </div>
              <div className="mt-3 text-left">
                <div className="font-serif text-xl lg:text-2xl text-[#1a1a1a]">{cat.name}</div>
                <div className="flex items-center gap-1 text-[10px] tracking-widest-2 uppercase mt-1.5 text-[#1a1a1a]">Explore More <span className="text-[12px] leading-none">›</span></div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
